import React, { Component, Fragment } from 'react';
import { AJAX_REQUEST } from "../../../Constants/AppConstants";
import $ from 'jquery';
import ChallengesLeftMenu from './ChallengesLeftMenu';
import ChallengesRightContent from './ChallengesRightContent';

class Challenges extends Component {
    constructor(props) {
        super(props);
        this.state = {
            response: {
                data: {
                    date_range: {},
                    distributor_list: []
                }
            },
            weeks: [],
            current_week: 1,
            challengeLoading: true,
            loading: true,
            error: null,
            challenge: [],
            selectedWeek: 'lifetime',
            date_range: [],
            start_date: '',
            end_date: '',
            x_day: ''
        }
        document.title = "Challenges -Prestige Labs";
    }

    componentDidMount() {
        document.querySelector("body").scrollIntoView();

        this.getChallengeDetails();
        this.intervalId = setInterval(() => {
            this.getChallengeDetails('interval');
            console.log('Timer running every 5 min');
        }, 50000);

    }
    componentWillUnmount() {
        clearInterval(this.intervalId);
        console.log('Interval cleared on unmount');
    }

    stopchallengeLoading = () => {
        this.setState({
            challengeLoading: false
        });
    }

    getChallengeDetails = (interval) => {
        if(interval == 'interval'){
            this.setState({
                challengeLoading: false
            });
        }else{
            this.setState({
                challengeLoading: true
            });
        }
      
        const path = window.location.pathname;
        const parts = path.split('/');
        const id = parts[parts.length - 1];

        let start_date = '';
        let end_date = ''
        let x_day = '';
        if (this.state.selectedWeek == 'custom') {
            start_date = this.state.start_date;
            end_date = this.state.end_date
        }else if(this.state.selectedWeek == 'x_day'){
            x_day = this.state.x_day;
        }

        const data = { challenge_id: id, week_number: this.state.selectedWeek, start_date: start_date, end_date: end_date, x_day: x_day}
        AJAX_REQUEST("POST", "distributor/getChallengeDetails", data)
            .then(results => {
                const response = results.response;
                if (parseInt(response.code) === 1000) {
                    this.setState({
                        response,
                        challenge: response.data.challenge,
                        date_range: response.data.date_range,
                        challengeLoading: false,
                        loading: false
                    });
                } else {
                    this.setState({ loading: false, error: response.message });
                }
            })
            .catch(error => {
                this.setState({ loading: false, error: error.message });
                console.error("AJAX error:", error);
            });
    }

    handleWeekChange = (week) => {
        this.setState({ selectedWeek: week }, () => {
            this.getChallengeDetails();
        });
    };

    getAttrData = (adata) => {
        this.setState({ start_date: adata.start_date, end_date: adata.end_date, selectedWeek: adata.filter_by, x_day:adata.x_day }, () => {
            this.getChallengeDetails();
        });
    }

    render() {

        return (
            <Fragment>
                {
                    this.state.loading ?
                        <div className="loading"></div>
                        :
                        <div className="leader_board_blk">
                            <h2 className="font_26 m-0 text_black let_spa_2 fw_el_bold">
                                {this.state.challenge?.header_name}
                            </h2>
                            <h3 className="font_16 mb_15 text_black fw_ar_reg">
                                Team Member Dashboard &gt; Contest Leaderboard &gt; {this.state.challenge?.header_name}
                            </h3>
                            <div className="d-flex flex-wrap">
                                <ChallengesLeftMenu
                                    weeks={this.state.date_range}
                                    challengeData = {this.state.response.data.challenge}
                                    stopChallengeLoading={this.stopChallengeLoading}
                                    onWeekChange={this.handleWeekChange}
                                    currentWeek={this.state.selectedWeek}
                                    getAttrData={this.getAttrData}
                                />
                                <div className="tab-content vertical_cus_tab_content" id="myTabContent">
                                    <ChallengesRightContent
                                        distData={this.state.response.data.distributor_list}
                                        currentWeek={this.state.current_week}
                                        challengeLoading={this.state.challengeLoading}
                                        onWeekChange={this.handleWeekChange}
                                    />
                                </div>
                            </div>
                        </div>
                }
            </Fragment>
        );
    }
}

export default Challenges;
